import * as React from 'react';
import {
  List, Datagrid, Edit, Create, Show, SimpleShowLayout,
  TextField, BooleanField, DateField,
  SimpleForm, TextInput, NumberInput, BooleanInput,
  TopToolbar, Button, EditButton, ShowButton
} from 'react-admin';
import { useRedirect } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';

const useTxtData = {
  page: { tableName: '称重数据' },
  table: {
    id: 'ID',
    Mac: '设备MAC',
    garbageNo: '垃圾编号',
    Role: '角色',
    UserId: '用户ID',
    Weight: '重量(g)',
    IsDeal: '是否处理',
    AtTime: '时间'
  }
};

const RowAction = (props) => {
  return (
    <div style={{ textAlign: 'right' }}>
      {/* <EditButton {...props} /><br />
      <ShowButton {...props} /> */}
    </div>
  );
};

export const LFDeviceWeightDataList = (props) => (
  <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }}
    exporter={false}
  >
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <TextField label={useTxtData.table.Mac} source="Mac" />
      <TextField label={useTxtData.table.garbageNo} source="garbageNo" />
      <TextField label={useTxtData.table.Role} source="Role" />
      <TextField label={useTxtData.table.UserId} source="UserId" />
      <TextField label={useTxtData.table.Weight} source="Weight" />
      <BooleanField label={useTxtData.table.IsDeal} source="IsDeal" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
      <RowAction />
    </Datagrid>
  </List>
);

export const LFDeviceWeightDataShow = (props) => {
  const redirect = useRedirect();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect('/Admin/LFDeviceWeightData')} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    }>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.Mac} source="Mac" />
        <TextField label={useTxtData.table.garbageNo} source="garbageNo" />
        <TextField label={useTxtData.table.Role} source="Role" />
        <TextField label={useTxtData.table.UserId} source="UserId" />
        <TextField label={useTxtData.table.Weight} source="Weight" />
        <BooleanField label={useTxtData.table.IsDeal} source="IsDeal" />
        <DateField label={useTxtData.table.AtTime} source="AtTime" />
      </SimpleShowLayout>
    </Show>
  );
};

export const LFDeviceWeightDataEdit = (props) => (
  <Edit title={'编辑' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Mac} source="Mac" />
      <NumberInput label={useTxtData.table.garbageNo} source="garbageNo" />
      <TextInput label={useTxtData.table.Role} source="Role" />
      <NumberInput label={useTxtData.table.UserId} source="UserId" />
      <NumberInput label={useTxtData.table.Weight} source="Weight" />
      <BooleanInput label={useTxtData.table.IsDeal} source="IsDeal" />
    </SimpleForm>
  </Edit>
);

export const LFDeviceWeightDataCreate = (props) => (
  <Create title={'新增' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Mac} source="Mac" />
      <NumberInput label={useTxtData.table.garbageNo} source="garbageNo" defaultValue={0} />
      <TextInput label={useTxtData.table.Role} source="Role" />
      <NumberInput label={useTxtData.table.UserId} source="UserId" defaultValue={0} />
      <NumberInput label={useTxtData.table.Weight} source="Weight" defaultValue={0} />
      <BooleanInput label={useTxtData.table.IsDeal} source="IsDeal" defaultValue={false} />
    </SimpleForm>
  </Create>
);